import React from "react";
import { useSearchParams } from "react-router-dom";
import { useCurrentParams } from "../../hooks/useCurrentParams";
import { getTodaysDate } from "../../shared/utils";

const FilterByDate = () => {
  const [currentSearchParams] = useCurrentParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleFilterDate = (e) => {
    if (e.target.name === "from") {
      setSearchParams({
        ...currentSearchParams,
        from: e.target.value,
      });
    } else {
      setSearchParams({
        ...currentSearchParams,
        to: e.target.value,
      });
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex justify-between items-center">
        <label htmlFor="from">From</label>
        <input
          type="date"
          id="from"
          name="from"
          className="outline-none bg-gray-darken text-gray-200 px-3 py-1 rounded-md"
          onChange={handleFilterDate}
          value={searchParams.get("from") || "2001-03-04"}
        />
      </div>
      <div className="flex justify-between items-center">
        <label htmlFor="from">To</label>
        <input
          type="date"
          id="to"
          name="to"
          className="outline-none bg-gray-darken text-gray-200 px-3 py-1 rounded-md"
          onChange={handleFilterDate}
          value={searchParams.get("to") || getTodaysDate()}
        />
      </div>
    </div>
  );
};

export default FilterByDate;
